import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../components/DashboardLayout';
import { EntityStampDistributionPanel } from '../components/admin/EntityStampDistributionPanel';
import { BankAccountInventoryPanel } from '../components/admin/BankAccountInventoryPanel';
import { PropertyAliasPanel } from '../components/admin/PropertyAliasPanel';
import { EntityIdDerivationAuditPanel } from '../components/admin/EntityIdDerivationAuditPanel';
import { EntityRecordsSyncPanel } from '../components/admin/EntityRecordsSyncPanel';
import { BankBalancesDiagnosticPanel } from '../components/admin/BankBalancesDiagnosticPanel';
import { BankBalanceBreakdownPanel } from '../components/admin/BankBalanceBreakdownPanel';
import { BankSyncFreshnessPanel } from '../components/admin/BankSyncFreshnessPanel';
import { DuplicateInvoiceCandidatesPanel } from '../components/admin/DuplicateInvoiceCandidatesPanel';
import { TotalBalanceCompositionPanel } from '../components/admin/TotalBalanceCompositionPanel';
import { MockDataAuditPanel } from '../components/admin/MockDataAuditPanel';
import { VictoriaMigrationPanel } from '../components/admin/VictoriaMigrationPanel';
import { DirectionMigrationPanel } from '../components/admin/DirectionMigrationPanel';
import { RecentApiErrorsPanel } from '../components/admin/RecentApiErrorsPanel';
import { BankAccountsReaderAuditPanel } from '../components/admin/BankAccountsReaderAuditPanel';
import { BankAccountManagementPanel } from '../components/admin/BankAccountManagementPanel';
import { CostTypeDistributionPanel } from '../components/admin/CostTypeDistributionPanel';
import { BrosBookingInvoiceLinkagePanel } from '../components/admin/BrosBookingInvoiceLinkagePanel';
import { OccupancyDiagnosticPanel } from '../components/admin/OccupancyDiagnosticPanel';
import { OccupancyAuditPanel } from '../components/admin/OccupancyAuditPanel';
import { BookingTracePanel } from '../components/admin/BookingTracePanel';
import { PropertyBookingsDumpPanel } from '../components/admin/PropertyBookingsDumpPanel';
import { UplistingSyncAuditPanel } from '../components/admin/UplistingSyncAuditPanel';
import { UplistingDiagnosticsPanel } from '../components/admin/UplistingDiagnosticsPanel';
import { UplistingWebhookHealthPanel } from '../components/admin/UplistingWebhookHealthPanel';
import { BackfillPropertyPanel } from '../components/admin/BackfillPropertyPanel';
import { SmoobuBackfillPanel } from '../components/admin/SmoobuBackfillPanel';
import { ReingestQuarantinedPanel } from '../components/admin/ReingestQuarantinedPanel';
import { PropertyCurrencyAuditPanel } from '../components/admin/PropertyCurrencyAuditPanel';
import { BROSInvoiceProbePanel } from '../components/admin/BROSInvoiceProbePanel';
import { BookingsHierarchyCheckPanel } from '../components/admin/BookingsHierarchyCheckPanel';
import { InvoiceStatusCheckPanel } from '../components/admin/InvoiceStatusCheckPanel';
import { BROSDataQualityPanel } from '../components/admin/BROSDataQualityPanel';
import { BROSSupplierDataDiagnosticPanel } from '../components/admin/BROSSupplierDataDiagnosticPanel';
import { BROSSyncHealthPanel } from '../components/admin/BROSSyncHealthPanel';
import { BROSRemovedPreviewPanel } from '../components/admin/BROSRemovedPreviewPanel';
import { PennylaneConnectionPanel } from '../components/admin/PennylaneConnectionPanel';
import { PennylaneConnectionTestPanel } from '../components/admin/PennylaneConnectionTestPanel';
import { PennylaneBankFeedDiscoveryPanel } from '../components/admin/PennylaneBankFeedDiscoveryPanel';
import { PennylaneBankFeedStatusPanel } from '../components/admin/PennylaneBankFeedStatusPanel';
import { XeroBankFeedStatusPanel } from '../components/admin/XeroBankFeedStatusPanel';
import { BillingVsSalesDivergencePanel } from '../components/admin/BillingVsSalesDivergencePanel';
import { PortfolioChartDivergencePanel } from '../components/admin/PortfolioChartDivergencePanel';
import { SmoobuCancelledAuditPanel } from '../components/admin/SmoobuCancelledAuditPanel';
import { SmoobuRawReservationPanel } from '../components/admin/SmoobuRawReservationPanel';
import { SmoobuCancellationBackfillPanel } from '../components/admin/SmoobuCancellationBackfillPanel';
import { SmoobuTypeVocabularyPanel } from '../components/admin/SmoobuTypeVocabularyPanel';
import { CancelledCohortRateCheckPanel } from '../components/admin/CancelledCohortRateCheckPanel';
import { NightlyRateCancelledExclusionPanel } from '../components/admin/NightlyRateCancelledExclusionPanel';
import { UplistingDuplicatesPanel } from '../components/admin/UplistingDuplicatesPanel';
import { UplistingStatusVocabularyPanel } from '../components/admin/UplistingStatusVocabularyPanel';
import { UplistingCancellationBackfillPanel } from '../components/admin/UplistingCancellationBackfillPanel';
import { ManagedPropertyAttributionPanel } from '../components/admin/ManagedPropertyAttributionPanel';
import { SmoobuPropertiesPanel } from '../components/admin/SmoobuPropertiesPanel';
import { HostawayDiagnosticsPanel } from '../components/admin/HostawayDiagnosticsPanel';
import { HostawayDiscoveryPanel } from '../components/admin/HostawayDiscoveryPanel';
import { BookingComFeeAuditPanel } from '../components/admin/BookingComFeeAuditPanel';
import { HostawayCommissionBackfillPanel } from '../components/admin/HostawayCommissionBackfillPanel';
import { MigrationAuditPanel } from '../components/admin/MigrationAuditPanel';
import { HostawayDedupPairProbePanel } from '../components/admin/HostawayDedupPairProbePanel';
import { MigrationBookingProbePanel } from '../components/admin/MigrationBookingProbePanel';
import { StatementReconciliationInspectPanel } from '../components/admin/StatementReconciliationInspectPanel';
import { WiseReferenceBackfillPanel } from '../components/admin/WiseReferenceBackfillPanel';
import { SmoobuReservationTracePanel } from '../components/admin/SmoobuReservationTracePanel';
import { UplistingCancellationFeeExposurePanel } from '../components/admin/UplistingCancellationFeeExposurePanel';
import { ManualCancelPanel } from '../components/admin/ManualCancelPanel';
import { GuestNameBackfillPanel } from '../components/admin/GuestNameBackfillPanel';
import { StaleConfirmedPanel } from '../components/admin/StaleConfirmedPanel';
import { SmoobuCommissionBackfillPanel } from '../components/admin/SmoobuCommissionBackfillPanel';
import { SmoobuCurrencyBackfillPanel } from '../components/admin/SmoobuCurrencyBackfillPanel';
import { CancelledMgmtFeeBackfillPanel } from '../components/admin/CancelledMgmtFeeBackfillPanel';
import { ManagementTypeBackfillPanel } from '../components/admin/ManagementTypeBackfillPanel';
import { AlEciReclassificationPanel } from '../components/admin/AlEciReclassificationPanel';
import { BrosClobberRestorePanel } from '../components/admin/BrosClobberRestorePanel';
import { ConsolidatePersonalPanel } from '../components/admin/ConsolidatePersonalPanel';
import { ManagedInvoiceCleanupPanel } from '../components/admin/ManagedInvoiceCleanupPanel';
import { CreditNoteDiffPanel } from '../components/admin/CreditNoteDiffPanel';
import { CreditNoteVatAuditPanel } from '../components/admin/CreditNoteVatAuditPanel';
import { EntityMismatchDiagnosticPanel } from '../components/admin/EntityMismatchDiagnosticPanel';
import { EntityMergePanel } from '../components/admin/EntityMergePanel';
import { EntityDuplicatesPanel } from '../components/admin/EntityDuplicatesPanel';
import { EntitiesFeedIntegrityPanel } from '../components/admin/EntitiesFeedIntegrityPanel';
import { EntityAccountTracePanel } from '../components/admin/EntityAccountTracePanel';
import { FxFreshnessPanel } from '../components/admin/FxFreshnessPanel';
import { FxBlastRadiusPanel } from '../components/admin/FxBlastRadiusPanel';
import { PennylaneInvoiceStatePanel } from '../components/admin/PennylaneInvoiceStatePanel';
import { FinalizeSequenceDiagnosticPanel } from '../components/admin/FinalizeSequenceDiagnosticPanel';
import { InvoiceGenerationSchedulerPanel } from '../components/admin/InvoiceGenerationSchedulerPanel';
import { SchedulerJobDurationsPanel } from '../components/admin/SchedulerJobDurationsPanel';
import { EventLoopLagPanel } from '../components/admin/EventLoopLagPanel';
import { DeadLetterChainsPanel } from '../components/admin/DeadLetterChainsPanel';
import { BuildCommitCard } from '../components/admin/BuildCommitCard';
import { RuntimeFingerprintCard } from '../components/admin/RuntimeFingerprintCard';
import { StatementScanWindowPanel } from '../components/admin/StatementScanWindowPanel';
import { CwcMatchPreviewPanel } from '../components/admin/CwcMatchPreviewPanel';
import { PennylaneReconciliationPreviewPanel } from '../components/admin/PennylaneReconciliationPreviewPanel';
import { WaterfallDeployCheckCard } from '../components/admin/WaterfallDeployCheckCard';
import { RuntimeConfigCard } from '../components/admin/RuntimeConfigCard';
import { MonitorSummaryCard } from '../components/admin/MonitorSummaryCard';
import { MatchingScheduleCard } from '../components/admin/MatchingScheduleCard';
import { ReceiptIngestSummaryCard } from '../components/admin/ReceiptIngestSummaryCard';
import { SupplierPaymentMatchPreviewPanel } from '../components/admin/SupplierPaymentMatchPreviewPanel';
import { StatementListMismatchPanel } from '../components/admin/StatementListMismatchPanel';
import { CleaningVerificationFeasibilityPanel } from '../components/admin/CleaningVerificationFeasibilityPanel';
import { CleaningVerificationPanel } from '../components/admin/CleaningVerificationPanel';
import { IntakeHealthPanel } from '../components/admin/IntakeHealthPanel';
import { BackfillExternalResIdPanel } from '../components/admin/BackfillExternalResIdPanel';
import { NoSupplierPropertyResolverPanel } from '../components/admin/NoSupplierPropertyResolverPanel';
import { PropertySupplierProbePanel } from '../components/admin/PropertySupplierProbePanel';
import { NoSupplierAuditPanel } from '../components/admin/NoSupplierAuditPanel';
import { StatementLandlordBackfillPanel } from '../components/admin/StatementLandlordBackfillPanel';
import { StatementMappingRepairsPanel } from '../components/admin/StatementMappingRepairsPanel';
import { AmountDateDiagnosticPanel } from '../components/admin/AmountDateDiagnosticPanel';
import { AnchorDateCoveragePanel } from '../components/admin/AnchorDateCoveragePanel';
import { BiImmoReconScopePanel } from '../components/admin/BiImmoReconScopePanel';
import { BiImmoReconClassificationTrustPanel } from '../components/admin/BiImmoReconClassificationTrustPanel';
import { AfpvPartialApplyPanel } from '../components/admin/AfpvPartialApplyPanel';
import { AfpvAutoReconPanel } from '../components/admin/AfpvAutoReconPanel';
import { RevenueDeltaDiagnosticPanel } from '../components/admin/RevenueDeltaDiagnosticPanel';
import { UKBookingCensusPanel } from '../components/admin/UKBookingCensusPanel';
import { UKHostawayListingManagementPanel } from '../components/admin/UKHostawayListingManagementPanel';
import { ReconAuditPanel } from '../components/admin/ReconAuditPanel';
import { ReconTracePanel } from '../components/admin/ReconTracePanel';
import { ReconciliationCoveragePanel } from '../components/admin/ReconciliationCoveragePanel';
import { MatchFunnelPanel } from '../components/admin/MatchFunnelPanel';
import { BrosPaidReentryPanel } from '../components/admin/BrosPaidReentryPanel';
import { MatchLifecycleProbePanel } from '../components/admin/MatchLifecycleProbePanel';
import { WriteProvenancePanel } from '../components/admin/WriteProvenancePanel';
import { ReconciliationPointerHealPanel } from '../components/admin/ReconciliationPointerHealPanel';
import { ConfirmStepperSelfHealPanel } from '../components/admin/ConfirmStepperSelfHealPanel';
import { BrosAllocationBackfillPanel } from '../components/admin/BrosAllocationBackfillPanel';
import { AutoFinalizeSchedulerPanel } from '../components/admin/AutoFinalizeSchedulerPanel';
import { WiseSupplierReconciliationCard } from '../components/admin/WiseSupplierReconciliationCard';
import { AccrecOutflowCensusCard } from '../components/admin/AccrecOutflowCensusCard';
import { CrossFeedDuplicatesPanel } from '../components/admin/CrossFeedDuplicatesPanel';
import { ContactsCollisionCheckPanel } from '../components/admin/ContactsCollisionCheckPanel';
import { VatGapPopulationPanel } from '../components/admin/VatGapPopulationPanel';
import { CommissionClassificationPanel } from '../components/admin/CommissionClassificationPanel';
import CommissionVerificationPanel from '../components/admin/CommissionVerificationPanel';
import { ExpenseCoveragePanel } from '../components/admin/ExpenseCoveragePanel';
import { InvoiceFileCoveragePanel } from '../components/admin/InvoiceFileCoveragePanel';
import { PennylaneInvoiceFilesPanel } from '../components/admin/PennylaneInvoiceFilesPanel';
import { CosReceiptRescuePanel } from '../components/admin/CosReceiptRescuePanel';
import { DrivePathAuditPanel } from '../components/admin/DrivePathAuditPanel';
import { InvoiceMetadataCensusPanel } from '../components/admin/InvoiceMetadataCensusPanel';
import { BROSInvoiceXeroLinkagePanel } from '../components/admin/BROSInvoiceXeroLinkagePanel';
import { InvoicePdfCoveragePanel } from '../components/admin/InvoicePdfCoveragePanel';
import { ClientInvoiceReconcilePanel } from '../components/admin/ClientInvoiceReconcilePanel';
import { ClientInvoiceCensusPanel } from '../components/admin/ClientInvoiceCensusPanel';
import { SupplierInvoiceCensusPanel } from '../components/admin/SupplierInvoiceCensusPanel';
import { InvoiceDuplicateCensusPanel } from '../components/admin/InvoiceDuplicateCensusPanel';
import { SupplierInvoiceDedupPanel } from '../components/admin/SupplierInvoiceDedupPanel';
import { IssuedVsInvoicedWaterfallPanel } from '../components/admin/IssuedVsInvoicedWaterfallPanel';
import { BookingReconcileGroupingPanel } from '../components/admin/BookingReconcileGroupingPanel';
import { InvoiceCurrencyDiagnosticPanel } from '../components/admin/InvoiceCurrencyDiagnosticPanel';
import { MatchingFxAttributionPanel } from '../components/admin/MatchingFxAttributionPanel';
import { InvoiceCurrencyBackfillPanel } from '../components/admin/InvoiceCurrencyBackfillPanel';
import { NonInvoiceCleanupPanel } from '../components/admin/NonInvoiceCleanupPanel';
import { InvoiceRowExplainPanel } from '../components/admin/InvoiceRowExplainPanel';
import { ZeroAmountInvoiceCensusPanel } from '../components/admin/ZeroAmountInvoiceCensusPanel';
import { RejectedInvoiceExposurePanel } from '../components/admin/RejectedInvoiceExposurePanel';
import { InvoiceTaxonomyBackfillPanel } from '../components/admin/InvoiceTaxonomyBackfillPanel';
import { ConfirmedMatchPaymentBackfillPanel } from '../components/admin/ConfirmedMatchPaymentBackfillPanel';
import { MatchEventBackfillPanel } from '../components/admin/MatchEventBackfillPanel';
import { StaleSuggestedMatchesSweepPanel } from '../components/admin/StaleSuggestedMatchesSweepPanel';
import { BrosEvidenceTierPanel } from '../components/admin/BrosEvidenceTierPanel';
import { ReceiptPaidReconciliationPanel } from '../components/admin/ReceiptPaidReconciliationPanel';
import { ReceiptPaidJobInspectorPanel } from '../components/admin/ReceiptPaidJobInspectorPanel';
import { ReceiptPaidTracePanel } from '../components/admin/ReceiptPaidTracePanel';
import { ReceiptPaidNoCandidateAutopsyPanel } from '../components/admin/ReceiptPaidNoCandidateAutopsyPanel';
import { SingleTokenContainmentAuditPanel } from '../components/admin/SingleTokenContainmentAuditPanel';
import { RecurringPaymentsCoveragePanel } from '../components/admin/RecurringPaymentsCoveragePanel';
import { ReceiptCohortCensusPanel } from '../components/admin/ReceiptCohortCensusPanel';
import { ReceiptCohortNormalizationRecomputePanel } from '../components/admin/ReceiptCohortNormalizationRecomputePanel';
import { MailboxIngestionCoveragePanel } from '../components/admin/MailboxIngestionCoveragePanel';
import { BankFeeCashbackPanel } from '../components/admin/BankFeeCashbackPanel';
import { InflowReferenceMatchingPanel } from '../components/admin/InflowReferenceMatchingPanel';
import { InvoicePayerPaymentDateBackfillPanel } from '../components/admin/InvoicePayerPaymentDateBackfillPanel';
import { AccountingReconciledEvidenceTierPanel } from '../components/admin/AccountingReconciledEvidenceTierPanel';
import { PortfolioReconciledEvidenceTierPanel } from '../components/admin/PortfolioReconciledEvidenceTierPanel';
import { ConfirmedMatchCategoryBackfillPanel } from '../components/admin/ConfirmedMatchCategoryBackfillPanel';
import { GmailMailboxEntityMappingPanel } from '../components/admin/GmailMailboxEntityMappingPanel';
import { GmailEntityBackfillPanel } from '../components/admin/GmailEntityBackfillPanel';
import { SupplierClientNameBackfillPanel } from '../components/admin/SupplierClientNameBackfillPanel';
import { SupplierCostLineagePanel } from '../components/admin/SupplierCostLineagePanel';
import { XeroInvoiceSyncPanel } from '../components/admin/XeroInvoiceSyncPanel';
import { XeroCreditNotesPanel } from '../components/admin/XeroCreditNotesPanel';
import { XeroTenantResolutionPanel } from '../components/admin/XeroTenantResolutionPanel';
import { XeroWouldQuarantinePanel } from '../components/admin/XeroWouldQuarantinePanel';
import { XeroCredentialsPanel } from '../components/admin/XeroCredentialsPanel';
import { XeroConnectionsPanel } from '../components/admin/XeroConnectionsPanel';
import { XeroConnectionsCensusPanel } from '../components/admin/XeroConnectionsCensusPanel';
import { XeroQuotaPanel } from '../components/admin/XeroQuotaPanel';
import { XeroInvoiceLookupPanel } from '../components/admin/XeroInvoiceLookupPanel';
import { XeroInvoiceLinkBackfillPanel } from '../components/admin/XeroInvoiceLinkBackfillPanel';
import { InvoiceContentCorrelationPanel } from '../components/admin/InvoiceContentCorrelationPanel';
import { BrosPdfReachabilityPanel } from '../components/admin/BrosPdfReachabilityPanel';
import { InvoiceSeriesAlignmentPanel } from '../components/admin/InvoiceSeriesAlignmentPanel';
import { BankConnectionsInventoryPanel } from '../components/admin/BankConnectionsInventoryPanel';
import { SecurityPosturePanel } from '../components/admin/SecurityPosturePanel';
import { ConfigReadinessCard } from '../components/admin/ConfigReadinessCard';
import { TokenDecryptabilityPanel } from '../components/admin/TokenDecryptabilityPanel';
import { GoogleConnectionHealthPanel } from '../components/admin/GoogleConnectionHealthPanel';
import { ConnectReadinessPanel } from '../components/admin/ConnectReadinessPanel';
import { BridgeConnectDryrunPanel } from '../components/admin/BridgeConnectDryrunPanel';
import { BridgeConnectChainDryrunPanel } from '../components/admin/BridgeConnectChainDryrunPanel';
import { BridgeBankResolutionPanel } from '../components/admin/BridgeBankResolutionPanel';
import { OBConfigConsistencyPanel } from '../components/admin/OBConfigConsistencyPanel';
import { OBConnectDryrunPanel } from '../components/admin/OBConnectDryrunPanel';
import { OBConnectChainDryrunPanel } from '../components/admin/OBConnectChainDryrunPanel';
import { OBSyncRunNowPanel } from '../components/admin/OBSyncRunNowPanel';
import { RevolutAmountCorrectionPanel } from '../components/admin/RevolutAmountCorrectionPanel';
import { GmailAmountReextractionPanel } from '../components/admin/GmailAmountReextractionPanel';
import { GmailReceiptReparsePanel } from '../components/admin/GmailReceiptReparsePanel';
import { ManagementStatementBackfillPanel } from '../components/admin/ManagementStatementBackfillPanel';
import { GmailInvoiceBackfillPanel } from '../components/admin/GmailInvoiceBackfillPanel';
import { StatementDuplicateCleanupPanel } from '../components/admin/StatementDuplicateCleanupPanel';
import { StatementDuplicateCensusPanel } from '../components/admin/StatementDuplicateCensusPanel';
import { StatementOrphanRepointPanel } from '../components/admin/StatementOrphanRepointPanel';
import { ReceivablesInvoiceLinkCensusPanel } from '../components/admin/ReceivablesInvoiceLinkCensusPanel';
import { ReceivablesInvoiceLinkRepairPanel } from '../components/admin/ReceivablesInvoiceLinkRepairPanel';
import { PennylaneReconPropagationPanel, PennylaneStuckInvoiceBackfillPanel, AfpvInvoiceComboMatchPanel } from '../components/admin/PennylaneReconPropagationPanel';
import { PennylanePushDiagnosticsPanel } from '../components/admin/PennylanePushDiagnosticsPanel';
import { ReconciliationDisagreementsPanel } from '../components/admin/ReconciliationDisagreementsPanel';
import { XeroInvoiceIdGapPanel } from '../components/admin/XeroInvoiceIdGapPanel';
import { InvoicePdfProvenancePanel } from '../components/admin/InvoicePdfProvenancePanel';
import { XeroInvoiceIdBackfillPanel } from '../components/admin/XeroInvoiceIdBackfillPanel';
import { PennylaneEntityBackfillPanel } from '../components/admin/PennylaneEntityBackfillPanel';
import { IntegrationConnectionStatePanel } from '../components/admin/IntegrationConnectionStatePanel';
import { BankFeedHealthPanel } from '../components/admin/BankFeedHealthPanel';
import { TrueLayerRegistryAuditPanel } from '../components/admin/TrueLayerRegistryAuditPanel';
import { EBCredentialsPanel } from '../components/admin/EBCredentialsPanel';
import { EBJwtCheckPanel } from '../components/admin/EBJwtCheckPanel';
import { EBCoveragePanel } from '../components/admin/EBCoveragePanel';
import { EBAccountMappingPanel } from '../components/admin/EBAccountMappingPanel';
import { EBConnectDryRunPanel } from '../components/admin/EBConnectDryRunPanel';
import { EBCurrencyBackfillPanel } from '../components/admin/EBCurrencyBackfillPanel';
import { GoCardlessStatusPanel } from '../components/admin/GoCardlessStatusPanel';
import { TransactionFieldCensusPanel } from '../components/admin/TransactionFieldCensusPanel';
import { TransactionSignCensusPanel } from '../components/admin/TransactionSignCensusPanel';
import { ManualStatementImportPanel } from '../components/admin/ManualStatementImportPanel';
import { BalanceSheetCensusPanel } from '../components/admin/BalanceSheetCensusPanel';
import { ReceivablesOverlapPanel } from '../components/admin/ReceivablesOverlapPanel';
import { CashJurisdictionSnapshotPanel } from '../components/admin/CashJurisdictionSnapshotPanel';
import { BankAccountSnapshotPanel } from '../components/admin/BankAccountSnapshotPanel';
import { SnapshotRenderTracePanel } from '../components/admin/SnapshotRenderTracePanel';
import { RecurringCostDetectionPanel } from '../components/admin/RecurringCostDetectionPanel';
import { RecurringCostMatchingRunNowPanel } from '../components/admin/RecurringCostMatchingRunNowPanel';
import { RecurringCostMatchRepairPanel } from '../components/admin/RecurringCostMatchRepairPanel';
import { StatementPayoutMatchRepairPanel } from '../components/admin/StatementPayoutMatchRepairPanel';
import { PnlReconciliationPanel } from '../components/admin/PnlReconciliationPanel';
import { ReconciliationSentinelPanel } from '../components/admin/ReconciliationSentinelPanel';
import { PortfolioRevenueParityPanel } from '../components/admin/PortfolioRevenueParityPanel';
import { OpexSourcePanel } from '../components/admin/OpexSourcePanel';
import { PayoutMatchCensusPanel } from '../components/admin/PayoutMatchCensusPanel';
import { MoneyStorageCensusPanel } from '../components/admin/MoneyStorageCensusPanel';
import { SubscriptionDetectDryrunPanel } from '../components/admin/SubscriptionDetectDryrunPanel';
import { SubscriptionBeneficiaryBackfillPanel } from '../components/admin/SubscriptionBeneficiaryBackfillPanel';
import { AccountDedupePanel } from '../components/admin/AccountDedupePanel';
import { AccountAdoptionPanel } from '../components/admin/AccountAdoptionPanel';
import { IngestionStatusPanel } from '../components/admin/IngestionStatusPanel';
import { ReceivablesBreakdownPanel } from '../components/admin/ReceivablesBreakdownPanel';
import { AlInvoiceDrilldownPanel } from '../components/admin/AlInvoiceDrilldownPanel';
import { AlInvoiceProvenancePanel } from '../components/admin/AlInvoiceProvenancePanel';
import { BrLtdInvoiceLinkageCensusPanel } from '../components/admin/BrLtdInvoiceLinkageCensusPanel';
import { AlManagedBookingMatrixPanel } from '../components/admin/AlManagedBookingMatrixPanel';
import { IntercompanyPositionPanel } from '../components/admin/IntercompanyPositionPanel';
import { Tier0DiagnosticsPanel } from '../components/admin/Tier0DiagnosticsPanel';
import { BankTransactionAttributionPanel } from '../components/admin/BankTransactionAttributionPanel';
import { BankTransactionEntityBackfillPanel } from '../components/admin/BankTransactionEntityBackfillPanel';
import { PennylaneBankfeedCounterpartyBackfillPanel } from '../components/admin/PennylaneBankfeedCounterpartyBackfillPanel';
import { PennylaneCounterpartyProbePanel } from '../components/admin/PennylaneCounterpartyProbePanel';
import { PennylaneCounterpartyBackfillPanel } from '../components/admin/PennylaneCounterpartyBackfillPanel';
import { SweepBlastRadiusPanel } from '../components/admin/SweepBlastRadiusPanel';
import { EntityFieldCorruptionCensusPanel } from '../components/admin/EntityFieldCorruptionCensusPanel';

function SectionHeader({ title, description }) {
  return (
    <div className="pt-4 first:pt-0">
      <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
      {description && (
        <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
      )}
    </div>
  );
}

function SubSectionHeader({ title }) {
  return (
    <div className="pt-2">
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">{title}</h3>
    </div>
  );
}

export function DiagnosticsPage() {
  const [searchParams] = useSearchParams();
  const probeId = searchParams.get('probe') || '';
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Diagnostics</h1>
          <p className="text-muted-foreground mt-1">
            Admin diagnostic tools for verifying computation correctness
          </p>
        </div>

        {/* ── System ───────────────────────────────────────────── */}
        <BuildCommitCard />
        <RuntimeFingerprintCard />
        <SchedulerJobDurationsPanel />
        <EventLoopLagPanel />
        <DeadLetterChainsPanel />
        <MonitorSummaryCard />
        <MatchingScheduleCard />
        <ReceiptIngestSummaryCard />
        <RuntimeConfigCard />
        <WaterfallDeployCheckCard />
        <SecurityPosturePanel />
        <TokenDecryptabilityPanel />
        <GoogleConnectionHealthPanel />
        <ConfigReadinessCard />
        <RecentApiErrorsPanel />

        {/* ── Group Inventory ────────────────────────────────────── */}
        <SectionHeader
          title="Group Inventory"
          description="Entity stamps, bank accounts, cost taxonomy, booking-invoice linkage"
        />
        <EntityRecordsSyncPanel />
        <EntityStampDistributionPanel />
        <BankAccountInventoryPanel />
        <EntityIdDerivationAuditPanel />
        <BankBalancesDiagnosticPanel />
        <BankBalanceBreakdownPanel />
        <BankSyncFreshnessPanel />
        <DuplicateInvoiceCandidatesPanel />
        <TotalBalanceCompositionPanel />
        <MockDataAuditPanel />
        <VictoriaMigrationPanel />
        <DirectionMigrationPanel />
        <BankAccountsReaderAuditPanel />
        <BankTransactionAttributionPanel />
        <BankTransactionEntityBackfillPanel />
        <PennylaneBankfeedCounterpartyBackfillPanel />
        <BankAccountManagementPanel />
        <CostTypeDistributionPanel />
        <BrosBookingInvoiceLinkagePanel />

        {/* ── Integration Health ─────────────────────────────────── */}
        <SectionHeader
          title="Integration Health"
          description="API connectivity and credential checks"
        />
        <BankFeedHealthPanel />
        <IntegrationConnectionStatePanel />
        <BankConnectionsInventoryPanel />
        <IngestionStatusPanel />
        <ConnectReadinessPanel />
        <BridgeBankResolutionPanel />
        <BridgeConnectDryrunPanel />
        <BridgeConnectChainDryrunPanel />
        <OBConfigConsistencyPanel />
        <TrueLayerRegistryAuditPanel />
        <OBConnectDryrunPanel />
        <OBConnectChainDryrunPanel />
        <OBSyncRunNowPanel />

        <SubSectionHeader title="Enable Banking" />
        <EBCredentialsPanel />
        <EBJwtCheckPanel />
        <EBConnectDryRunPanel />
        <EBCoveragePanel />
        <EBAccountMappingPanel />
        <EBCurrencyBackfillPanel />

        <SubSectionHeader title="GoCardless" />
        <GoCardlessStatusPanel />

        <TransactionFieldCensusPanel />
        <TransactionSignCensusPanel />
        <MoneyStorageCensusPanel />
        <SubscriptionDetectDryrunPanel />

        <SubSectionHeader title="Manual Statement Import" />
        <ManualStatementImportPanel />

        <IntakeHealthPanel />
        <InvoiceCurrencyDiagnosticPanel />
        <MatchingFxAttributionPanel />
        <FxFreshnessPanel />
        <FxBlastRadiusPanel />
        <XeroInvoiceSyncPanel />
        <XeroCreditNotesPanel />
        <XeroTenantResolutionPanel />
        <XeroWouldQuarantinePanel />
        <XeroCredentialsPanel />
        <XeroConnectionsPanel />
        <XeroConnectionsCensusPanel />
        <XeroQuotaPanel />
        <XeroInvoiceLookupPanel />
        <XeroInvoiceLinkBackfillPanel />
        <InvoiceContentCorrelationPanel />
        <BrosPdfReachabilityPanel />
        <InvoiceSeriesAlignmentPanel />
        <PennylaneConnectionPanel />
        <PennylaneCounterpartyProbePanel />
        <PennylaneConnectionTestPanel />
        <PennylaneBankFeedDiscoveryPanel />
        <PennylaneBankFeedStatusPanel />
        <XeroBankFeedStatusPanel />
        <PennylaneInvoiceStatePanel />
        <PennylaneReconciliationPreviewPanel />
        <PennylaneReconPropagationPanel />
        <PennylaneStuckInvoiceBackfillPanel />
        <PennylanePushDiagnosticsPanel />
        <ReconciliationDisagreementsPanel />
        <AfpvInvoiceComboMatchPanel />
        <Tier0DiagnosticsPanel />
        <AmountDateDiagnosticPanel />
        <AnchorDateCoveragePanel />
        <BiImmoReconScopePanel />
        <BiImmoReconClassificationTrustPanel />
        <AfpvPartialApplyPanel />
        <AfpvAutoReconPanel />
        <RevenueDeltaDiagnosticPanel />
        <FinalizeSequenceDiagnosticPanel />
        <InvoiceGenerationSchedulerPanel />

        {/* ── Balance Sheet ─────────────────────────────────────── */}
        <SectionHeader
          title="Balance Sheet"
          description="Property ownership, valuation, loan, and receivable coverage"
        />
        <BalanceSheetCensusPanel />
        <ReceivablesOverlapPanel />
        <CashJurisdictionSnapshotPanel />
        <BankAccountSnapshotPanel />
        <SnapshotRenderTracePanel />

        {/* ── Data Quality ───────────────────────────────────────── */}
        <SectionHeader
          title="Data Quality"
          description="Cross-checks across bookings, invoices, occupancy, and reconciliation"
        />

        <SubSectionHeader title="Supplier Data" />
        <SupplierCostLineagePanel />
        <BROSSupplierDataDiagnosticPanel />
        <WiseSupplierReconciliationCard />
        <AccrecOutflowCensusCard />

        <SubSectionHeader title="Invoicing" />
        <AutoFinalizeSchedulerPanel />
        <IssuedVsInvoicedWaterfallPanel />
        <BillingVsSalesDivergencePanel />
        <BROSDataQualityPanel />
        <InvoiceStatusCheckPanel />
        <BROSInvoiceProbePanel initialBrosId={probeId} />
        <BROSInvoiceXeroLinkagePanel />
        <InvoicePdfCoveragePanel />
        <InvoicePdfProvenancePanel />
        <ClientInvoiceCensusPanel />
        <SupplierInvoiceCensusPanel />
        <InvoiceDuplicateCensusPanel />
        <SupplierInvoiceDedupPanel />
        <ClientInvoiceReconcilePanel />
        <ReceivablesBreakdownPanel />
        <AlInvoiceDrilldownPanel />
        <AlInvoiceProvenancePanel />
        <BrLtdInvoiceLinkageCensusPanel />
        <AlManagedBookingMatrixPanel />
        <IntercompanyPositionPanel />

        <SubSectionHeader title="Reconciliation" />
        <ReconciliationSentinelPanel />
        <PayoutMatchCensusPanel />
        <PnlReconciliationPanel />
        <PortfolioRevenueParityPanel />
        <OpexSourcePanel />
        <ReconAuditPanel />
        <ReconTracePanel />
        <ReconciliationCoveragePanel />
        <MatchFunnelPanel />
        <BrosPaidReentryPanel />
        <MatchLifecycleProbePanel />
        <WriteProvenancePanel />
        <ReconciliationPointerHealPanel />
        <ConfirmStepperSelfHealPanel />
        <ConfirmedMatchCategoryBackfillPanel />
        <BrosAllocationBackfillPanel />
        <CrossFeedDuplicatesPanel />
        <VatGapPopulationPanel />
        <XeroInvoiceIdGapPanel />
        <XeroInvoiceIdBackfillPanel />
        <PennylaneEntityBackfillPanel />
        <BookingReconcileGroupingPanel />
        <CwcMatchPreviewPanel />
        <StatementPayoutMatchRepairPanel />
        <SupplierPaymentMatchPreviewPanel />
        <NoSupplierPropertyResolverPanel />
        <PropertySupplierProbePanel />
        <NoSupplierAuditPanel />

        <SubSectionHeader title="Portfolio / Occupancy" />
        <PropertyAliasPanel />
        <RecurringCostDetectionPanel />
        <RecurringCostMatchingRunNowPanel />
        <RecurringCostMatchRepairPanel />
        <PropertyCurrencyAuditPanel />
        <OccupancyDiagnosticPanel />
        <OccupancyAuditPanel />
        <PortfolioChartDivergencePanel />
        <ManagedPropertyAttributionPanel />
        <StaleConfirmedPanel />
        <CancelledCohortRateCheckPanel />
        <NightlyRateCancelledExclusionPanel />

        <SubSectionHeader title="Smoobu" />
        <SmoobuPropertiesPanel />
        <SmoobuCancelledAuditPanel />
        <SmoobuRawReservationPanel />
        <SmoobuCancellationBackfillPanel />
        <SmoobuTypeVocabularyPanel />

        <SubSectionHeader title="Hostaway" />
        <HostawayDiagnosticsPanel />
        <HostawayDiscoveryPanel />
        <BookingComFeeAuditPanel />
        <HostawayCommissionBackfillPanel />
        <MigrationAuditPanel />
        <HostawayDedupPairProbePanel />
        <MigrationBookingProbePanel />
        <SmoobuReservationTracePanel />
        <UKBookingCensusPanel />
        <UKHostawayListingManagementPanel />
        <StatementReconciliationInspectPanel />

        <SubSectionHeader title="Uplisting" />
        <UplistingDuplicatesPanel />
        <UplistingStatusVocabularyPanel />
        <UplistingCancellationFeeExposurePanel />

        <SubSectionHeader title="Entities" />
        <EntityAccountTracePanel />
        <EntityDuplicatesPanel />
        <EntitiesFeedIntegrityPanel />
        <EntityMismatchDiagnosticPanel />
        <EntityMergePanel />
        <EntityFieldCorruptionCensusPanel />
        <ContactsCollisionCheckPanel />

        <SubSectionHeader title="Statements / Cleaning / Commission" />
        <StatementScanWindowPanel />
        <StatementListMismatchPanel />
        <CleaningVerificationPanel />
        <CommissionClassificationPanel />
        <CommissionVerificationPanel />
        <ExpenseCoveragePanel />
        <InvoiceFileCoveragePanel />
        <PennylaneInvoiceFilesPanel />
        <CosReceiptRescuePanel />
        <DrivePathAuditPanel />
        <InvoiceMetadataCensusPanel />
        <CleaningVerificationFeasibilityPanel />

        {/* ── Sync Health ────────────────────────────────────────── */}
        <SectionHeader
          title="Sync Health"
          description="Pipeline sync state, staleness, and live probes"
        />
        <BROSSyncHealthPanel />
        <BROSRemovedPreviewPanel />
        <UplistingSyncAuditPanel />
        <UplistingDiagnosticsPanel />
        <UplistingWebhookHealthPanel />

        {/* ── Hierarchy / Schema ─────────────────────────────────── */}
        <SectionHeader
          title="Hierarchy / Schema"
          description="Structural checks on booking IDs, property mappings, and traces"
        />
        <BookingsHierarchyCheckPanel />
        <BookingTracePanel />
        <PropertyBookingsDumpPanel />

        {/* ── Actions ────────────────────────────────────────────── */}
        <SectionHeader
          title="Actions"
          description="One-off data operations"
        />
        <InvoiceCurrencyBackfillPanel />
        <NonInvoiceCleanupPanel />
        <InvoiceRowExplainPanel />
        <ZeroAmountInvoiceCensusPanel />
        <RejectedInvoiceExposurePanel />
        <InvoiceTaxonomyBackfillPanel />
        <ConfirmedMatchPaymentBackfillPanel />
        <MatchEventBackfillPanel />
        <StaleSuggestedMatchesSweepPanel />
        <BrosEvidenceTierPanel />
        <ReceiptPaidReconciliationPanel />
        <ReceiptPaidJobInspectorPanel />
        <ReceiptPaidTracePanel />
        <ReceiptPaidNoCandidateAutopsyPanel />
        <SingleTokenContainmentAuditPanel />
        <RecurringPaymentsCoveragePanel />
        <ReceiptCohortCensusPanel />
        <ReceiptCohortNormalizationRecomputePanel />
        <MailboxIngestionCoveragePanel />
        <BankFeeCashbackPanel />
        <InflowReferenceMatchingPanel />
        <InvoicePayerPaymentDateBackfillPanel />
        <AccountingReconciledEvidenceTierPanel />
        <PortfolioReconciledEvidenceTierPanel />
        <SweepBlastRadiusPanel />
        <GmailMailboxEntityMappingPanel />
        <GmailEntityBackfillPanel />
        <SupplierClientNameBackfillPanel />
        <PennylaneCounterpartyBackfillPanel />
        <BackfillPropertyPanel />
        <SubscriptionBeneficiaryBackfillPanel />
        <AccountDedupePanel />
        <AccountAdoptionPanel />
        <SmoobuBackfillPanel />
        <ReingestQuarantinedPanel />
        <UplistingCancellationBackfillPanel />
        <SmoobuCommissionBackfillPanel />
        <SmoobuCurrencyBackfillPanel />
        <GuestNameBackfillPanel />
        <CancelledMgmtFeeBackfillPanel />
        <ManagementTypeBackfillPanel />
        <AlEciReclassificationPanel />
        <BrosClobberRestorePanel />
        <ManualCancelPanel />
        <ConsolidatePersonalPanel />
        <CreditNoteDiffPanel />
        <CreditNoteVatAuditPanel />
        <ManagedInvoiceCleanupPanel />
        <BackfillExternalResIdPanel />
        <StatementMappingRepairsPanel />
        <StatementLandlordBackfillPanel />
        <RevolutAmountCorrectionPanel />
        <WiseReferenceBackfillPanel />
        <GmailAmountReextractionPanel />
        <GmailReceiptReparsePanel />
        <GmailInvoiceBackfillPanel />
        <ManagementStatementBackfillPanel />
        <StatementDuplicateCleanupPanel />
        <StatementDuplicateCensusPanel />
        <StatementOrphanRepointPanel />
        <ReceivablesInvoiceLinkCensusPanel />
        <ReceivablesInvoiceLinkRepairPanel />
      </div>
    </DashboardLayout>
  );
}
